import { useCallback, useRef } from "react";

import { useFocusEffect } from "@medbillai/ui";

/** Refetches when the screen regains focus; a native stack keeps it mounted. */
export const useRefetchOnRefocus = (refetch: () => Promise<unknown>) => {
  const focusedBefore = useRef(false);
  useFocusEffect(
    useCallback(() => {
      if (focusedBefore.current) {
        void refetch().catch(() => undefined);
      }
      focusedBefore.current = true;
    }, [refetch]),
  );
};
